import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-ds-card-actions',
  templateUrl: './ds-card-actions.component.html',
  styleUrls: ['./ds-card-actions.component.scss']
})
export class DsCardActionsComponent {
  @HostBinding('class.ds-card__actions') readonly hostClass = true;
}
